import { createModel } from '@rematch/core';
import { QualificationInfoList } from '../../api/ApiClient';
import apiConnector from '../../api/ApiConnector';
import { IQualificationsFilters } from 'components/reduxModels';

const initialState: State = {
    qualifications: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setQualifications: (state, qualifications: State['qualifications']): State => ({ ...state, qualifications }),
    },
    effects: (dispatch: any) => ({
        async getQualifications(payload: IQualificationsFilters) {
            const result = await apiConnector.execApi(
                dispatch,
                apiClient => apiClient.getQualifications(
                    payload.occupationalStandardId,
                    payload.readyToUse,
                    payload.residency,
                    payload.searchField,
                    payload.searchTerm,
                    payload.page,
                    payload.pageSize,
                    payload.sortOrder,
                    payload.sortField,
                ),
            );
            if (!result) return;
            this.setQualifications(result);
        },
    }),
});

interface State {
    qualifications: QualificationInfoList | null;
}
